import { render } from "./CheckDomain.vue?vue&type=template&id=4d16ba6c"
import script from "./CheckDomain.vue?vue&type=script&lang=js"
export * from "./CheckDomain.vue?vue&type=script&lang=js"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__